<template>
  <div class="images">
    <h2>Tła</h2>
    <div class="list">
      <el-card shadow="hover" class="box-card image" v-for="(image, index) in bg" :key="index">
        <img @click="add(image)" :src="image" width="100" />
      </el-card>
    </div>
  </div>
</template>

<script>
  import Editor from '../../classes/Editor';
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('file', [
        'bg',
      ]),
    },
    methods: {
      add(img) {
        Editor.addImage(img)
      }
    }
  }
</script>

<style lang="less">
  .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .images {
    .el-collapse-item__content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      .el-card__body {
        height: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .el-button {
          display: none;
        }
      }
    }
    .box-card {
      width: 31%;
      height: 100px;
      &.image {
        font-size: 12px;
        margin-bottom: 10px;
        img {
          max-height: 100%;
          max-width: 100%;
          width: auto;
        }
      }
    }
  }
</style>
